/**
 * aligned's `customers` collection (`models/manager/customer/customer_model.dart`).
 * A customer is the billing/org entity a `Manager` belongs to.
 */
export interface Customer {
  id: string;
  name: string;
  contactEmail: string;
  billingEmail: string | null;
  contactName: string | null;
  contactPhone: string | null;
  primaryManagerId: string | null;
  streetAddress: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  dataSetPrefix: string | null;
  defaultRateCardId: string | null;
  postalCode: string | null;
  blacklistedCountryCodes: string[];
}

type Data = Record<string, unknown>;

const str = (v: unknown): string | null => (typeof v === 'string' ? v : null);
const strList = (v: unknown): string[] =>
  Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];

export function mapCustomer(id: string, data: Data): Customer {
  return {
    id,
    name: str(data.name) ?? '',
    contactEmail: str(data.contactEmail) ?? '',
    billingEmail: str(data.billingEmail),
    contactName: str(data.contactName),
    contactPhone: str(data.contactPhone),
    primaryManagerId: str(data.primaryManagerId),
    streetAddress: str(data.streetAddress),
    city: str(data.city),
    state: str(data.state),
    country: str(data.country),
    dataSetPrefix: str(data.dataSetPrefix),
    defaultRateCardId: str(data.defaultRateCardId),
    postalCode: str(data.postalCode),
    blacklistedCountryCodes: strList(data.blacklistedCountryCodes),
  };
}
